/* eslint-disable sort-keys-fix/sort-keys-fix */
// NOTE: name should be lowercase as lowercase serializer is used.
export const PRINCIPAL_ADMIN_ROUTE = {
  name: 'principaladmin',
  route(): string[] {
    return ['/' + this.name];
  },
  CREATE_ACCOUNT: {
    name: 'createaccount',
    route(): string[] {
      return [...PRINCIPAL_ADMIN_ROUTE.route(), this.name];
    }
  },
  CREATE_BATCH: {
    name: 'createbatch',
    route(): string[] {
      return [...PRINCIPAL_ADMIN_ROUTE.route(), this.name];
    }
  },
  PREMIUM_CODES: {
    name: 'premiumcodes',
    route(): string[] {
      return [...PRINCIPAL_ADMIN_ROUTE.route(), this.name];
    }
  }
};
